import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { observeNotification } from "rxjs/internal/Notification";
import { SHARED_LIB_CONFIG, SharedLibConfig } from "../config/lib-config";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PowerTransformerService {
    private pathApi: string;
    constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
        this.pathApi = this.config.pathApi + 'cim/powerTransformer/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAllPowerTransformersFromSubstationId(substationId: number){
        return this.http.post(`${this.pathApi}getAllPowerTransformersFromSubstationId?substationId=${substationId}`, {
            headers: this.headers,
            observe: 'response',
        });
    }
    
    getBaseVoltageForPowerTransformer(powerTransformerId: number){
        return this.http.post(`${this.pathApi}getBaseVoltageForPowerTransformer?powerTransformerId=${powerTransformerId}`, {
            headers: this.headers,
            observe: 'response',
        });
    }

    getAll(obj: any){
        return this.http.post(`${this.pathApi}getAll`, obj, {
            headers: this.headers,
            observe: 'response'
        });
    }

    create(obj: any){
        return this.http.post(`${this.pathApi}create`, obj, {
            headers: this.headers,
            observe: 'response'
        })
    }

    getById(obj: any){
        return this.http.get(`${this.pathApi}getById?id=${obj}`, {
            headers: this.headers,
            observe: 'response'
        })
    }

    downloadFile(obj: any){
        return this.http.post(`${this.pathApi}downloadFile`, obj, {
            headers: this.headers,
            observe: 'response'
        })
    }

    getPowerTransformersBySubstationId(obj: any){
        return this.http.get(`${this.pathApi}getPowerTransformersBySubstationId?substationId=${obj}`, {
            headers: this.headers,
            observe: 'response'
        })
    }

    getPowerTransformersBySubstationIdAndVoltage(obj: any){
        return this.http.post(`${this.pathApi}getPowerTransformerBySubstationIdAndVoltage`, obj, {
            headers: this.headers,
            observe: 'response'
        })
    }

    generateTemplate(utilityId: number) {
        return this.http.get(`${this.pathApi}generateTemplate?utilityId=${utilityId}`, {
            headers: this.headers,
            observe: 'response'
        })
    }

    uploadFile(data: any) {
        return this.http.post(`${this.pathApi}uploadFile`, data);
    }
}